import Select from "@hudson/ui/components/FormFields/Select";
import Field from "@hudson/ui/components/FormFields/Field";

function ValidationType({
  fieldName,
  label,
  values,
}: {
  fieldName: string;
  label: string;
  values: be.FieldValue[];
}): JSX.Element | null {
  return (
    <Field
      defaultValue={String(values[0]?.value)}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Select
          className="w-60"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          value={String(value)}
          values={values}
        />
      )}
      fieldName={fieldName}
      label={label}
    />
  );
}

export default ValidationType;
